import { merchantActionTypes } from './action-types';
import { IAction, IMerchantContextState } from './merchant-interfaces';

export const merchantsReducer = (state: IMerchantContextState, action?: IAction): IMerchantContextState => {
	switch (action.type) {
		case merchantActionTypes.FETCH_STATUS_SUCCESS: {
			return { ...state, merchantStatus: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_DATA_SUCCESS: {
			return {
				...state,
				confirmApplicationData: action.payload,
				isConfirmApplicationDataLoading: false
			};
		}
		case merchantActionTypes.FETCH_FEES_DATA_SUCCESS: {
			return {
				...state,
				feeTableData: { ...state.feeTableData, ...action.payload },
				isConfirmApplicationDataLoading: false
			};
		}
		case merchantActionTypes.FETCH_MERCHANTS_LISTS: {
			return {
				...state,
				merchantsLists: action.payload,
				isMerchantListsLoading: false
			};
		}
		case merchantActionTypes.START_WIDGET_CONFIGURATIONS_LOADING: {
			return { ...state, isWidgetConfigurationDataLoading: true };
		}
		case merchantActionTypes.FETCH_WIDGET_CONFIGURATION_DATA: {
			return {
				...state,
				widgetConfigurationData: action.payload,
				isWidgetConfigurationDataLoading: false
			};
		}
		case merchantActionTypes.FETCH_PARTNER_LIST_SELECTOR: {
			return { ...state, partnersListSelector: action.payload };
		}
		case merchantActionTypes.FETCH_SALES_AGENCY_LIST_SELECTOR: {
			return { ...state, salesAgencyListSelector: action.payload };
		}
		case merchantActionTypes.SET_PARTNER_LIST_DEFAULT: {
			return {
				...state,
				partnersList: [],
				isPartnerListLoading: true
			};
		}
		case merchantActionTypes.SET_PARTNER_LIST_DATA_LOADING: {
			return { ...state, isPartnerListLoading: action.payload };
		}
		case merchantActionTypes.FETCH_PARTNER_LIST: {
			return {
				...state,
				partnersList: action.payload,
				isPartnerListLoading: false,
			};
		}
		case merchantActionTypes.SET_MERCHANT_DETAILS_DATA_DEFAULT: {
			return {
				...state,
				merchantData: null,
				isMerchantDataLoading: true
			};
		}
		case merchantActionTypes.FETCH_MERCHANT_DATA: {
			return {
				...state,
				merchantData: action.payload,
				isMerchantDataLoading: false
			};
		}
		case merchantActionTypes.FETCH_MERCHANT_FEES: {
			return {
				...state,
				merchantFee: action.payload
			};
		}
		case merchantActionTypes.FETCH_MERCHANT_FEE_HISTORY: {
			return {
				...state,
				historyFeesData: action.payload
			};
		}
		case merchantActionTypes.START_LOADING: {
			return {
				...state,
				isMerchantDataSaving: true,
			};
		}
		case merchantActionTypes.END_LOADING: {
			return {
				...state,
				isMerchantDataSaving: false,
			};
		}
		case merchantActionTypes.FETCH_STANDARD_FEES: {
			return {
				...state,
				standardFees: action.payload
			};
		}
		case merchantActionTypes.FETCH_FEE: {
			return {
				...state,
				feesArray: action.payload
			};
		}
		case merchantActionTypes.SET_APPLICATION_DATA_LOADING: {
			return { ...state, isApplicationDataLoading: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_DATA: {
			return {
				...state,
				applicationData: action.payload,
				isApplicationDataLoading: false
			};
		}
		case merchantActionTypes.SET_APPLICATION_DETAILS_DATA_DEFAULT: {
			return {
				...state,
				applicationData: null,
				isApplicationDataLoading: true
			};
		}
		case merchantActionTypes.FETCH_IS_STANDARD_FEE_SELECTED: {
			return {
				...state,
				isStandardFeeSelected: action.payload
			};
		}
		case merchantActionTypes.FETCH_MERCHANTS_LIST_REPORT: {
			return {
				...state,
				merchantsListReport: action.payload
			};
		}
		case merchantActionTypes.FETCH_MERCHANTS_LIST_REPORT_DATA: {
			return {
				...state,
				merchantsListReportData: action.payload
			};
		}
		case merchantActionTypes.SET_GENERAL_ERROR: {
			return {
				...state,
				generalError: action.payload
			};
		}
		case merchantActionTypes.START_SITES_LIST_LOADING: {
			return {
				...state,
				isSitesListLoading: true
			};
		}
		case merchantActionTypes.FETCH_SITES_LIST: {
			return {
				...state,
				sitesList: action.payload,
				isSitesListLoading: false
			};
		}
		case merchantActionTypes.START_WEBHOOK_EVENT_TYPES_LOADING: {
			return {
				...state,
				isWebhookEventTypesLoading: true
			};
		}
		case merchantActionTypes.FETCH_WEBHOOK_EVENT_TYPES: {
			return {
				...state,
				webhookEventTypes: action.payload,
				isWebhookEventTypesLoading: false
			};
		}
		case merchantActionTypes.START_WEBHOOK_LOGS_LOADING: {
			return {
				...state,
				isWebhooksLogDataLoading: true
			};
		}
		case merchantActionTypes.FETCH_WEBHOOK_LOGS_DATA: {
			return {
				...state,
				webhooksLogData: action.payload,
				webhooksLogTotalItemCount: action.totalItemCount,
				isWebhooksLogDataLoading: false
			};
		}
		case merchantActionTypes.SET_WEBHOOK_LOGS_TABLE_PAGINATION: {
			return {
				...state,
				webhooksLogTablePageNumber: action.payload.pageNumber,
				webhooksLogTablePageSize: action.payload.pageSize,
			};
		}
		case merchantActionTypes.START_LIST_OF_MERCHANTS_LOADING: {
			return {
				...state,
				isListOfMerchantsLoading: true
			};
		}
		case merchantActionTypes.FETCH_LIST_OF_MERCHANTS: {
			return {
				...state,
				listOfMerchants: action.payload,
				isListOfMerchantsLoading: false
			};
		}
		case merchantActionTypes.SET_CHOSEN_MERCHANT: {
			return {
				...state,
				chosenMerchant: action.payload
			};
		}
		case merchantActionTypes.START_NEW_PARTNER_LOADING: {
			return {
				...state,
				isSavingNewPartner: true
			};
		}
		case merchantActionTypes.END_NEW_PARTNER_LOADING: {
			return {
				...state,
				isSavingNewPartner: false
			};
		}
		case merchantActionTypes.SET_MERCHANT_FEES: {
			return {
				...state,
				merchantFees: action.payload
			};
		}
		case merchantActionTypes.SET_DEFAULT_FEE: {
			return { ...state, defaultFees: action.payload };
		}
		case merchantActionTypes.SET_ALL_DEFAULT_FEE: {
			return { ...state, allDefaultFees: action.payload };
		}
		case merchantActionTypes.SET_GLOBAL_LOADING: {
			return {
				...state,
				isGlobalTransparentLoader: action.payload
			};
		}
		case merchantActionTypes.START_FETCH_CHECKOUT_LOADING: {
			return {
				...state,
				isCheckoutConfigurationLoading: true
			};
		}
		case merchantActionTypes.FETCH_CHECKOUT_CONFIGURATION: {
			return {
				...state,
				checkoutConfiguration: action.payload,
				isCheckoutConfigurationLoading: false
			};
		}
		case merchantActionTypes.FETCH_MCC_LIST: {
			return {
				...state,
				mccList: action.payload
			};
		}
		case merchantActionTypes.START_SFTP_CONFIG_LOADING: {
			return {
				...state,
				isSftpLoading: true
			};
		}
		case merchantActionTypes.FETCH_SFTP_CONFIG: {
			return {
				...state,
				sftpConfig: action.payload,
				isSftpLoading: false
			};
		}
		case merchantActionTypes.SET_AGENCY_LIST_LOADING: {
			return { ...state, isAgenciesListLoading: action.payload };
		}
		case merchantActionTypes.FETCH_AGENCY_LIST: {
			return {
				...state,
				agenciesList: action.payload,
				isAgenciesListLoading: false
			};
		}
		case merchantActionTypes.SET_NEW_AGENCY_CREATION_LOADING: {
			return { ...state, isSavingNewAgency: action.payload };
		}
		case merchantActionTypes.SET_CREATING_NEW_SALES_AGENT_LOADING: {
			return { ...state, isSavingNewSalesAgent: action.payload };
		}
		case merchantActionTypes.SET_MERCHANT_NAMES: {
			return { ...state, merchantNames: action.payload };
		}
		case merchantActionTypes.SET_PARTNER_NAMES_LOADING: {
			return { ...state, isPartnerNamesListLoading: action.payload };
		}
		case merchantActionTypes.SET_PARTNER_NAMES: {
			return { ...state, partnerNames: action.payload, isPartnerNamesListLoading: false };
		}
		case merchantActionTypes.START_SENSE_JS_VALIDATION_LOADING: {
			return { ...state, isSenseJSValidationLoading: true };
		}
		case merchantActionTypes.GET_SENSE_JS_VALIDATION_RESULT: {
			return {
				...state,
				senseJSValidationResult: action.payload,
				isSenseJSValidationLoading: false,
			};
		}
		case merchantActionTypes.SET_ACCOUNT_LIST_LOADING: {
			return { ...state, isAccountListLoading: action.payload };
		}
		case merchantActionTypes.FETCH_ACCOUNT_LIST: {
			return { ...state, accountList: action.payload, isAccountListLoading: false };
		}
		case merchantActionTypes.SET_NEW_ACCOUNT_LOADING: {
			return { ...state, isAddNewAccountLoading: action.payload };
		}
		case merchantActionTypes.SET_ACCOUNTS_LIST_SELECTOR: {
			return { ...state, accountListSelector: action.payload };
		}
		case merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_ACTIVE_LIST_DATA_LOADING: {
			return { ...state, isFundsReserveConfigActiveListDataLoading: action.payload };
		}
		case merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_ACTIVE: {
			return { ...state, fundsReserveConfigActiveListData: action.payload, isFundsReserveConfigActiveListDataLoading: false };
		}
		case merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_INACTIVE_LIST_DATA_LOADING: {
			return { ...state, isFundsReserveConfigInactiveListDataLoading: action.payload };
		}
		case merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_INACTIVE: {
			return { ...state, fundsReserveConfigInActiveListData: action.payload, isFundsReserveConfigInactiveListDataLoading: false };
		}
		case merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_LISTS: {
			return { ...state, fundsReserveConfigLists: action.payload };
		}
		case merchantActionTypes.SET_PLATFORM_SYSTEM: {
			return { ...state, platformSystem: action.payload };
		}
		case merchantActionTypes.SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING: {
			return { ...state, isMerchantFundsReserveConfigLoading: action.payload };
		}
		case merchantActionTypes.SET_AUDIT_LOGS_LOADING: {
			return { ...state, isAuditLogsListLoading: action.payload };
		}
		case merchantActionTypes.FETCH_AUDIT_LOGS_LIST: {
			return {
				...state,
				auditLogsList: action.payload,
				auditLogsListTotalItemCount: action.totalItemCount,
				isAuditLogsListLoading: false,
			};
		}
		case merchantActionTypes.SET_AUDIT_LOGS_TABLE_PAGINATION: {
			return {
				...state,
				auditLogsListTablePageSize: action.payload.pageSize,
				auditLogsListTablePageNumber: action.payload.pageNumber
			};
		}
		case merchantActionTypes.SET_PARTNER_FEES_ADDING_LOADING: {
			return { ...state, isPartnerFeesAddingLoading: action.payload };
		}
		case merchantActionTypes.SET_PARTNER_FEES_LOADING: {
			return { ...state, isPartnerFeesLoading: action.payload };
		}
		case merchantActionTypes.FETCH_PARTNER_FEES: {
			return {
				...state,
				isPartnerFeesLoading: false,
				partnerFees: action.payload
			};
		}
		case merchantActionTypes.SET_INTEGRATION_PARTNER_LIST_LOADING: {
			return { ...state, isIntegrationPartnersListSelectorLoading: action.payload };
		}
		case merchantActionTypes.FETCH_INTEGRATION_PARTNER_LIST_SELECTOR: {
			return {
				...state,
				isIntegrationPartnersListSelectorLoading: false,
				integrationPartnersListSelector: action.payload
			};
		}
		case merchantActionTypes.SET_WHITELABEL_PARTNER_LIST_LOADING: {
			return { ...state, isWhitelabelPartnersListSelectorLoading: action.payload };
		}
		case merchantActionTypes.FETCH_WHITELABEL_PARTNER_LIST_SELECTOR: {
			return {
				...state,
				isWhitelabelPartnersListSelectorLoading: false,
				whitelabelPartnersListSelector: action.payload
			};
		}
		case merchantActionTypes.SET_SIGN_UP_LOADING: {
			return { ...state, signUpLoading: action.payload };
		}
		case merchantActionTypes.SET_CONFIRM_AGREEMENT: {
			return { ...state, isConfirmAgreement: action.payload };
		}
		case merchantActionTypes.SET_QUICK_APP_LOADING: {
			return { ...state, isQuickApplicationLoading: action.payload };
		}
		case merchantActionTypes.SET_QUICK_APP_DATA_LOADING: {
			return { ...state, isQuickApplicationDataLoading: action.payload };
		}
		case merchantActionTypes.SET_QUICK_APP_DATA: {
			return { ...state, quickApplicationData: action.payload, isQuickApplicationDataLoading: false };
		}
		case merchantActionTypes.SET_APPLICATION_SUMMARY_LOADING: {
			return { ...state, isApplicationSummaryLoading: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_SUMMARY: {
			return { ...state, applicationSummary: action.payload, isApplicationSummaryLoading: false };
		}
		case merchantActionTypes.IS_APPLICATION_VIEW_DATA_LOADING: {
			return { ...state, isApplicationViewDataLoading: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_VIEW: {
			return { ...state, applicationViewData: action.payload, isApplicationViewDataLoading: false };
		}
		case merchantActionTypes.SET_APPLICATION_DATA_TO_DEFAULT: {
			return { ...state, applicationViewData: action.payload, isApplicationViewDataLoading: true };
		}

		case merchantActionTypes.IS_SET_APPLICATION_VIEW_DATA_LOADING: {
			return { ...state, isSavingApplicationViewDataLoading: action.payload };
		}
		case merchantActionTypes.IS_APPLICATION_VIEW_DATA_SUBMISSION_LOADING: {
			return { ...state, isApplicationViewDataSubmissionLoading: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_VIEW_FEES: {
			return { ...state, applicationViewFees: action.payload };
		}
		case merchantActionTypes.SET_APPLICATION_EDIT_STATUS: {
			return { ...state, applicationFormEditStatus: action.payload };
		}
		case merchantActionTypes.SET_RISK_MODAL_LOADING: {
			return { ...state, isRiskRequestLoading: action.payload };
		}
		case merchantActionTypes.SET_REINVITE_LOADING: {
			return { ...state, isReinviteLoading: action.payload };
		}
		case merchantActionTypes.SET_DOCUMENT_LOADING: {
			return { ...state, isDocumentLoading: action.payload };
		}
		case merchantActionTypes.FETCH_APPLICATION_DETAILS_LOGS: {
			return { ...state, applicationDetailsLogs: action.payload, isApplicationDetailsLogsLoading: false };
		}
		case merchantActionTypes.SET_APPLICATION_DETAILS_LOGS_LOADING: {
			return { ...state, isApplicationDetailsLogsLoading: action.payload };
		}
		case merchantActionTypes.FETCH_FAIL: {
			// toaster.push(toastMessage({
			// 	text: 'Update fail',
			// 	type: 'error'
			// }), { placement: 'topEnd' });
			return {
				...state,
				isConfirmApplicationDataLoading: false,
				isWidgetConfigurationDataLoading: false,
				isMerchantListsLoading: false,
				isMerchantDataLoading: false,
				isMerchantDataSaving: false,
				isPartnerListLoading: false,
				isWebhooksLogDataLoading: false,
				isSitesListLoading: false,
				isListOfMerchantsLoading: false,
				isWebhookEventTypesLoading: false,
				isSavingNewPartner: false,
				isGlobalTransparentLoader: false,
				isCheckoutConfigurationLoading: false,
				isSftpLoading: false,
				isSenseJSValidationLoading: false,
			};
		}

		case merchantActionTypes.SET_WORKFLOWS_LOADING: {
			return { ...state, isWorkflowsLoading: action.payload };
		}
		case merchantActionTypes.FETCH_WORKFLOWS: {
			return {
				...state,
				workflows: action.payload.workflows,
				workflowsData: action.payload.workflowsData,
				isWorkflowsLoading: false
			};
		}
		case merchantActionTypes.SET_PARTNER_DETAILS_DEFAULT: {
			return {
				...state,
				partnerDetailsData: null,
				isPartnerDetailsDataLoading: true,
			};
		}
		case merchantActionTypes.FETCH_PARTNER_DETAILS: {
			return { ...state, partnerDetailsData: action.payload, isPartnerDetailsDataLoading: false };
		}
		case merchantActionTypes.SET_PARTNER_FILTERS: {
			return { ...state, ...action.payload };
		}
		default: {
			return state;
		}
	}
};
